// Seeded randomness for the engine, the site, and their tests.

/** How many uint32 values there are. A uint32 divided by this lands in [0, 1). */
export const UINT32_RANGE = 2 ** 32;

/** A uint32 hash or state, turned into a number in [0, 1). */
export function unitFromUint32(value: number): number {
  return (value >>> 0) / UINT32_RANGE;
}

/** mulberry32: a small, fast seeded generator of numbers in [0, 1), with a good spread. */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return unitFromUint32(t ^ (t >>> 14));
  };
}

/** A random uint32 seed. */
export function randomSeed(): number {
  return Math.floor(Math.random() * UINT32_RANGE);
}
